<script>
export default {
  methods: {
    //修改数据中心
    changeDataCenter(value) {
      if(value === 1) {
        this.$store.commit('saveGmt', 8) //中国
      } else if(value === 2){
        this.$store.commit('saveGmt', -8) //美西
      } else if(value === 3){
        this.$store.commit('saveGmt', 2) //中欧
      } else if(value === 4){
        this.$store.commit('saveGmt', 5) //印度
      } else if(value === 5){
        this.$store.commit('saveGmt', -5) //美东
      } else if(value === 6){
        this.$store.commit('saveGmt', 1) //西欧
      }

      this.$store.commit('saveDataCenter', value)
      this.$router.go(0)
    }
  },

  computed: {
    value() {
      if(this.$store.state.dataCenter.dataCenter) {
        const obj = this.$store.state.dataCenter.list.find(item => item.value == this.$store.state.dataCenter.dataCenter)
        if(obj) return this.$i18n.locale === 'zh' ? obj.zh : obj.en

        return ''
      }

      return ''
    }
  }
}
</script>

<template>
  <!--多数据中心-->
  <el-dropdown placement="bottom" @command="changeDataCenter">
    <!--当前选中数据中心-->
    <span class="data-center">
      {{ value }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>

    <!--下拉语言-->
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in $store.state.dataCenter.list" :key="item.value" :command="item.value" :class="[$store.state.dataCenter.dataCenter == item.value ? 'acitve' : '']">
        {{ $i18n.locale === 'zh' ? item.zh : item.en }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style scoped lang="scss">
.data-center{
  cursor: pointer;
}
</style>
